<template>
  <div v-if="accesses">
    <tabs
      :niveau="2"
      :links="tabList"
      :level="2"
      :mode="'emitter'"
      @changeView="changeView"
      class="has-background-light is-border-bottom ">
    </tabs>
    <router-view
      :key="$route.name"
      :accesses="accesses"
      :allotments="programAllotments"
      :mandats="mandats"
      :agence-access="agenceAccess"
      :program="program"
      :lots="programLots"
      :accesses-count="accessesCount"
      :current-access-page="currentAccessPage"
      :current-access-total-page="currentAccessTotalPage"
      @deleteAccess="deleteAccess"
      @createdAccess="createdAccess"
      @loadAccessPage="$emit('getProgramAccesses', $event)"
      @updateAccess="$emit('getProgramAccesses')"></router-view>
  </div>
</template>

<script>
import { Access } from '@/mixins'

export default {
  name: 'ProgramAccesses',
  mixins: [Access],
  props: {
    accesses: {
      type: Array
    },
    accessesCount: {
      type: Number
    },
    currentAccessPage: {
      type: Number
    },
    currentAccessTotalPage: {
      type: Number
    },
    programAllotments: {
      type: Array
    },
    program: {
      required: true
    },
    mandats: {
      type: Array
    },
    agenceAccess: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  computed: {
    programAccessView () {
      return this.$route.name
    },
    tabList () {
      let tabs = []
      tabs.push({ label: `${this.mandats.length} Canal(aux) ouvert`, link: 'MandatLightList' })
      tabs.push({ label: `${this.agenceAccess.length} Agence(s) ouvert`, link: 'AgenceAccessLightList' })
      tabs.push({ label: `${this.accessesCount} Mandat(s) ouvert`, link: 'AccessLightList' })
      if (this.isPromoteur && this.isAdmin) {
        tabs.push({ label: `Création mandat`, link: 'ProgramAccessForm' })
      }
      return tabs
    }
  },
  async mounted () {
    if (!this.tabList.map(x => x.link).includes(this.programAccessView)) {
      this.$router.replace({ name: 'AccessLightList' })
    }
  },
  methods: {
    changeView (link) {
      this.$router.push({ name: link })
    },
    deleteAccess (pk) {
      this.$emit('deleteAccess', pk)
    },
    async createdAccess () {
      await this.$emit('getProgramAccesses')
      this.$router.replace({ name: 'AccessLightList' })
    }
  }
}
</script>
